import React, {useEffect, useState} from 'react';
import './Gyogik_search.css';
import {useLocation} from 'react-router-dom';
import noImage from './no-img.png';

const Gyogik_search = () => {
    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const itemsPerPage = 10;
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem('token');
        const secretKey = localStorage.getItem('secretKey');
        const detailData = location.state?.id;
        const detailDatab = location.state?.bid;

        if (!token || !secretKey) return;

        const offset = (page - 1) * itemsPerPage;
        const url = `/backend/Gyogik_search?token=${encodeURIComponent(token)}&secretKey=${encodeURIComponent(secretKey)}&detailData=${encodeURIComponent(detailData)}&detailDatab=${encodeURIComponent(detailDatab)}&offset=${offset}&limit=${itemsPerPage}`;

        setLoading(true);

        fetch(url)
            .then(res => res.json())
            .then(data => {
                setResult(data);
                setLoading(false);


            })
            .catch(() => setLoading(false));

        window.scrollTo({top: 0, behavior: 'smooth'});
    }, [page]);

    return (
        <div className="container">
            <div className="page">
                <div className="AppG App-headerG gnb_bsG">
                    <header style={{width: "100%"}}>
                        <div className="gnb_1">
                            <button onClick={() => window.history.back()} className="arrow-button">
                                <span className="arrow-icon"></span>
                            </button>
                            <span className="title">교직원 검색결과</span>
                        </div>
                    </header>
                    <div className="body">
                        {loading ?
                            <div className="loader-container">
                                <div className="loader"></div>
                            </div> : (
                                <>
                                    {result.map((row, index) => (
                                        <div className="list_info" key={index}>
                                            <div className="box">
                                                <div className="pic">
                                                    <img
                                                        loading="lazy"
                                                        style={{width: '90px', height: '110px'}}
                                                        src={row.PHOTO_URL || noImage}
                                                        onError={(e) => {
                                                            e.target.src = noImage;
                                                        }}
                                                        alt={`${row.USER_NM} 사진`}
                                                    />
                                                </div>
                                                <div className="txt">
                                                    <span>{row.USER_NM}</span>
                                                    <a>{row.ORG_NM}/{row.USER_CLS}</a>
                                                    <a>{row.WORK}</a>
                                                    <a>HP : {row.HAND_PHONE}</a>
                                                    <a>E-MAIL : {row.EMAIL}</a>
                                                    <a>OFFICE : {row.HT_TEL}</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gyogik_search;